module.exports = __webpack_public_path__ + "img/CHECKLIST.5021f79a.svg";